import Vue from 'vue';
import moment from 'moment';
import { nanoid } from 'nanoid';
import {
  createNewId,
  set,
  firestoreDocumentByPath,
  onSnapshot,
  firestoreCollection,
} from '../firebase/firestore';
import { MUTATION_REGISTER_SNAPSHOT_LISTENER } from './constants';
import { types as analysesTypes } from './analyses';

const MODULE_PREFIX = 'missions';

const ACTION_WRITE_FULFILLMENT = 'writeFulfillment';
const ACTION_WRITE_FULFILLMENT_COMMENT = 'writeFulfillmentComment';
const ACTION_FETCH_FULFILLMENTS = 'fetchFulfillments';
const ACTION_FETCH_FULFILLMENT_COMMENTS = 'fetchFulfillmentComments';
const ACTION_CREATE_MISSION = 'createMission';

const GETTER_FULFILLMENTS = 'getFulfillments';
const GETTER_FULFILLMENT_COMMENTS = 'getFulfillmentComments';

const MUTATION_RECEIVED_FULFILLMENTS = 'receivedFulfillments';
const MUTATION_RECEIVED_FULFILLMENT_COMMENTS = 'receivedFulfillmentComments';

const initialState = {
  user: [],
  fulfillments: {},
  fulfillmentComments: {},
};

const actions = {
  [ACTION_WRITE_FULFILLMENT]: async (_, { analysisId, userAnalysisId, fulfillment }) => {
    const missionPath = `/analyses/${analysisId}/userAnalyses/${userAnalysisId}/missionFulfillments/${fulfillment.id}`;

    console.log('ACTION_WRITE_MISSION', missionPath, fulfillment);
    set(
      firestoreDocumentByPath(missionPath),
      fulfillment,
    );
  },
  [ACTION_CREATE_MISSION]: async ({ dispatch }, { text, selectedColleagues, codeClassification, userAnalysis }) => {
    const date = moment().format('YYYY-MM-DD');
    const tagged = selectedColleagues.map(colleague => ({
      id: nanoid(),
      fulfillmentId: nanoid(),
      colleague,
      status: 'todo',
      creationDate: date,
      replyDate: '',
      content: '',
      replies: [],
    }));
    const newMission = {
      content: text,
      date,
      status: 'todo',
      codeClassification,
      tagged,
    };
    const userAnalysisPayload = {
      element: {
        ...newMission,
        type: 'mission',
      },
      userAnalysis,
    };

    await dispatch(
      analysesTypes.actions.addUserAnalysisElement,
      userAnalysisPayload,
      { root: true },
    );
    await dispatch(
      analysesTypes.actions.addUsersToAnalysis,
      selectedColleagues,
      { root: true },
    );
  },
  [ACTION_WRITE_FULFILLMENT_COMMENT]: async (
    _,
    { analysisId, userAnalysisId, fulfillmentId, fulfillmentCommentId, comment },
  ) => {
    const id = fulfillmentCommentId || createNewId();
    const commentPath = `/analyses/${analysisId}/userAnalyses/${
      userAnalysisId}/missionFulfillments/${fulfillmentId}/missionFulfillmentComments/${id}`;
    set(
      firestoreDocumentByPath(commentPath),
      comment,
    );
  },

  [ACTION_FETCH_FULFILLMENTS]: async ({ commit }, { analysisId, userAnalysisId, missionId }) => {
    const missionFulfillmentsPath = `/analyses/${analysisId}/userAnalyses/${userAnalysisId}/missionFulfillments`;

    const snapshotListener = onSnapshot(
      firestoreCollection(missionFulfillmentsPath)
        .where('missionId', '==', missionId),
      onFulfillmentsSnapshot.bind(this, commit, missionId),
    );

    commit(
      MUTATION_REGISTER_SNAPSHOT_LISTENER,
      { snapshotListener, id: `missionFulfillments/${missionId}` },
      { root: true },
    );
  },
  [ACTION_FETCH_FULFILLMENT_COMMENTS]: async ({ commit }, { analysisId, userAnalysisId, fulfillmentId }) => {
    const commentsCollection = `/analyses/${analysisId}/userAnalyses/${
      userAnalysisId}/missionFulfillments/${fulfillmentId}/missionFulfillmentComments`;

    const snapshotListener = onSnapshot(
      firestoreCollection(commentsCollection),
      onFulfillmentCommentsSnapshot.bind(this, commit, fulfillmentId),
    );

    commit(
      MUTATION_REGISTER_SNAPSHOT_LISTENER,
      { snapshotListener, id: `missionFulfillmentComments/${fulfillmentId}` },
      { root: true },
    );
  },

};

const getters = {
  [GETTER_FULFILLMENTS]: state => missionId => state.fulfillments[missionId],
  [GETTER_FULFILLMENT_COMMENTS]: state => fulfillmentId => state.fulfillmentComments[fulfillmentId],
};

const mutations = {
  [MUTATION_RECEIVED_FULFILLMENTS]: (state, { missionId, fulfillments }) => {
    Vue.set(state.fulfillments, missionId, fulfillments);
  },
  [MUTATION_RECEIVED_FULFILLMENT_COMMENTS]: (state, { fulfillmentId, comments }) => {
    Vue.set(state.fulfillmentComments, fulfillmentId, comments);
  },
};

const onFulfillmentsSnapshot = (commit, missionId, snapshot) => {
  commit(MUTATION_RECEIVED_FULFILLMENTS, { missionId, fulfillments: snapshot.docs.map(d => d.data()) });
};

const onFulfillmentCommentsSnapshot = (commit, fulfillmentId, snapshot) => {
  commit(MUTATION_RECEIVED_FULFILLMENT_COMMENTS, { fulfillmentId, comments: snapshot.docs.map(d => d.data()) });
};

export default {
  namespaced: true, state: initialState, actions, getters, mutations,
};

export const types = {
  actions: {
    writeFulfillment: `${MODULE_PREFIX}/${ACTION_WRITE_FULFILLMENT}`,
    writeFulfillmentComment: `${MODULE_PREFIX}/${ACTION_WRITE_FULFILLMENT_COMMENT}`,
    fetchFulfillments: `${MODULE_PREFIX}/${ACTION_FETCH_FULFILLMENTS}`,
    fetchFulfillmentComments: `${MODULE_PREFIX}/${ACTION_FETCH_FULFILLMENT_COMMENTS}`,
    createMission: `${MODULE_PREFIX}/${ACTION_CREATE_MISSION}`,
  },
  getters: {
    missionFulfillments: `${MODULE_PREFIX}/${GETTER_FULFILLMENTS}`,
    missionFulfillmentComments: `${MODULE_PREFIX}/${GETTER_FULFILLMENT_COMMENTS}`,
  },
};
